import { observer } from 'mobx-react-lite'
import { type NotesTabViewModel } from './NotesTabViewModel'
import { NotesDialogContainer } from '@/features/jobs/details/components/CapturedInformationCard/NotesDialog/NotesDialogContainer'
import { NotesTab } from '@/features/jobs/details/components/CapturedInformationCard'

export interface NotesTabContainerProps {
  vm: NotesTabViewModel
}

export const NotesTabContainer = observer(function NotesTabContainer({
  vm,
}: NotesTabContainerProps) {
  return (
    <NotesTab
      label={vm.isInfoGatheringStep ? 'Notes' : 'Instructions'}
      isRequired={
        !!(vm.notesSupportingItem?.required && vm.isInfoGatheringStep)
      }
      isProvided={!vm.isInfoGatheringStep}
      text={vm.notesSupportingItemInput?.text}
      canEdit={vm.canEditNotes}
      editButtonLabel={
        vm.notesSupportingItemInput?.text ? 'Edit notes' : 'Add notes'
      }
      onEdit={vm.showNotesDialog}
      dialog={<NotesDialogContainer vm={vm.notesDialogVm} />}
    />
  )
})
